
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "../../../../node_modules/moment/moment";
import { useNavigate } from "../../../../node_modules/react-router-dom/index";
import {
  setDate,
  setToggle,
  setYear,
} from "../../../Redux/Slices/Patient/PatienCalender";
import { getPatientSubscriptions } from "../../../services/patient/subscriptions";
import { EmptySubscriptions } from "../../UI/EmptySubscriptions";
import { SubscriptionCard } from "./SubscriptionCard";
import styles from "./subscriptions.module.css";

export const Inactive = ({payment}) => {
  const [inActiveSubscriptions, setInctiveSubscriptions] = useState([]);
  const { selectedDate } = useSelector((i) => i.DateFilterSlice);
  const navigate = useNavigate();

  const FinalArr = inActiveSubscriptions || [];
  const dispatch = useDispatch();

  const finalData = FinalArr.filter((service) => {
    return selectedDate?.includes("All")
      ? service.created_at.includes(selectedDate.split(" ")?.[1])
      : service.created_at.includes(moment(selectedDate).format("YYYY-MM"));
  });

  useEffect(() => {
    return () => {
      dispatch(setDate(`All ${new Date().getFullYear()}`));
      dispatch(setToggle(false));
      dispatch(setYear(new Date().getFullYear()));
    };
  }, []);

  useEffect(() => {
    getPatientSubscriptions(2).then((res) =>
    setInctiveSubscriptions(res?.data?.list)
    );
  }, []);

  const apiCall = () => {
    getPatientSubscriptions(2).then((res) =>
    setInctiveSubscriptions(res?.data?.list)
    );
  }

  return (
    <div
      className={styles.container}
      style={
        finalData?.length
          ? {}
          : { justifyContent: "center", translate: "0 50px" }
      }
    >
      {finalData.length ? (
        finalData?.map((item) => {
          return (
            <SubscriptionCard
              name={item.name}
              subscription_id = {item?.id}
              validity={item.validity}
              extended={item.extended_validity}
              paymentMode={item?.payment_mode}
              amount={item.net_price}
              created_at={item?.created_at}
              paymentLink = {item?.payment?.short_url}
              onClick={() => navigate("details", { state: item })}
              // onClick={() => navigate("details", { 
              //   state: { item },
                
              // })}
              payment={payment}
              apiCall={apiCall}
              

             
            />
          );
        })
      ) : (
        
     <EmptySubscriptions title="There are no subscription at this time." />
      )}
    </div>
  );
};
